import { TODO } from '@b2b/types/core';
import { IInjectable } from '@uirouter/angularjs';
import { ApiService } from '../services/api/types';

export function CustomFieldsDataResolver(): IInjectable {
  return [
    'ApiService',
    'HelpersService',
    function (ApiService: ApiService, HelpersService: TODO) {
      return ApiService.customFields.list(HelpersService.getPaginator());
    },
  ];
}
